import React from 'react';

export const PagerDutySearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-259.5"
				y="-646.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="#04AB38"
			/>
			<path
				d="M9.78616 12.0784C9.78635 12.0782 9.78645 12.078 9.78645 12.0777C9.78645 10.145 9.78763 8.21234 9.78411 6.27966C9.78411 6.10613 9.78176 5.99826 10.0198 6.00002C12.4115 6.01409 14.8033 5.9965 17.195 6.02523C18.5486 6.04164 19.84 6.36349 21.006 7.07811C22.434 7.95219 23.2295 9.25421 23.4821 10.8916C23.753 12.6473 23.4681 14.2941 22.3889 15.7409C21.4708 16.9726 20.1917 17.6233 18.7045 17.9106C17.7795 18.0894 16.8433 18.1128 15.9077 18.1199C13.9556 18.1351 12.0029 18.1216 10.0502 18.1322C9.8187 18.1333 9.78059 18.0548 9.78176 17.8478C9.7888 15.9251 9.78587 14.0018 9.78587 12.0791C9.78587 12.0788 9.78597 12.0786 9.78616 12.0784Z"
				fill="#FEFEFE"
			/>
			<path
				d="M9.80268 23.3091C9.80268 22.5095 9.80678 21.7093 9.79916 20.9097C9.79741 20.7356 9.81909 20.6541 10.0295 20.6576C10.8584 20.6716 11.6879 20.6699 12.5168 20.6576C12.7091 20.6546 12.7367 20.7221 12.7361 20.8909C12.7302 22.5201 12.7291 24.1492 12.7373 25.7778C12.7384 25.9671 12.6775 26.0005 12.5057 25.9988C11.6768 25.9906 10.8473 25.9882 10.0184 25.9999C9.82613 26.0029 9.79741 25.936 9.79916 25.7666C9.80737 24.9471 9.80268 24.1281 9.80268 23.3085V23.3091Z"
				fill="#FEFEFE"
			/>
			<path
				d="M12.7242 11.9952C12.7242 10.9112 12.7265 9.82788 12.7212 8.74393C12.7206 8.58388 12.7353 8.50123 12.9358 8.5024C14.2735 8.51236 15.6113 8.48598 16.9484 8.51705C17.7111 8.53464 18.4544 8.70699 19.1285 9.09332C20.0137 9.60042 20.4393 10.3948 20.529 11.3873C20.5952 12.123 20.563 12.8493 20.247 13.5352C19.7429 14.6297 18.8049 15.1222 17.69 15.3614C17.1923 15.468 16.6858 15.4927 16.1775 15.4927C15.1229 15.4921 14.0684 15.4827 13.0143 15.4997C12.7576 15.5038 12.716 15.42 12.7189 15.1884C12.7312 14.1244 12.7242 13.0598 12.7242 11.9958V11.9952Z"
				fill="#04AB38"
			/>
		</svg>
	);
};
